// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/bm__feelbar.js" defer="defer"></script>
console.log('feature')